/* Mobile navigation bar — Categories bottom sheet.
   Self-contained: no dependency on the theme's own drawer scripts, so it
   cannot be broken by a theme update touching them. Scoped by data attribute
   rather than id so more than one instance would not collide. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mnbcatReady === '1') return;
    root.dataset.mnbcatReady = '1';

    var style = root.getAttribute('data-mnbcat-style') || 'accordion';
    var sheet = root.querySelector('[data-mnbcat-sheet]');
    var backBtn = root.querySelector('[data-mnbcat-back]');
    var titleEl = root.querySelector('[data-mnbcat-title]');
    var rootList = root.querySelector('[data-mnbcat-root]');
    var triggers = document.querySelectorAll('[data-mnbcat-trigger="' + root.id + '"]');
    var rootTitle = titleEl ? titleEl.textContent.trim() : '';

    if (!sheet) return;

    var subs = Array.prototype.slice.call(root.querySelectorAll('[data-mnbcat-sub]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-mnbcat-open]'));

    function closeAllSubs() {
      subs.forEach(function (s) { s.classList.remove('is-open'); });
      rows.forEach(function (r) { r.setAttribute('aria-expanded', 'false'); });
      if (backBtn) backBtn.hidden = true;
      if (titleEl) titleEl.textContent = rootTitle;
    }

    function openSheet() {
      closeAllSubs();
      root.classList.add('is-active');
      /* One frame between display and the transform change, otherwise the
         browser has nothing to animate from. */
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.body.classList.add('mnbcat-locked');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    }

    function closeSheet() {
      root.classList.remove('is-open');
      document.body.classList.remove('mnbcat-locked');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) {
          root.classList.remove('is-active');
          closeAllSubs();
        }
      }, 300);
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (root.classList.contains('is-open')) closeSheet();
        else openSheet();
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-mnbcat-close]')).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeSheet();
      });
    });

    rows.forEach(function (row) {
      var key = row.getAttribute('data-mnbcat-open');
      var sub = root.querySelector('[data-mnbcat-sub="' + key + '"]');
      if (!sub) return;

      row.addEventListener('click', function () {
        var wasOpen = sub.classList.contains('is-open');

        if (style === 'drill') {
          subs.forEach(function (s) { s.classList.remove('is-open'); });
          sub.classList.add('is-open');
          if (backBtn) backBtn.hidden = false;
          if (titleEl) titleEl.textContent = row.getAttribute('data-mnbcat-title') || rootTitle;
          sub.scrollTop = 0;
          return;
        }

        /* Accordion: one section open at a time, so a long menu does not turn
           into an unscrollable wall. */
        subs.forEach(function (s) { s.classList.remove('is-open'); });
        rows.forEach(function (r) { r.setAttribute('aria-expanded', 'false'); });
        if (!wasOpen) {
          sub.classList.add('is-open');
          row.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        closeAllSubs();
        if (rootList) rootList.focus({ preventScroll: true });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      if (style === 'drill' && backBtn && !backBtn.hidden) closeAllSubs();
      else closeSheet();
    });

    /* Swipe down on the handle or the header to dismiss. Deliberately limited
       to those two strips: starting it anywhere in the sheet would fight the
       list's own scrolling. */
    var dragFrom = 0;
    var dragging = false;

    function dragStart(e) {
      if (!root.classList.contains('is-open')) return;
      dragFrom = e.touches ? e.touches[0].clientY : e.clientY;
      dragging = true;
      root.classList.add('is-dragging');
    }

    function dragMove(e) {
      if (!dragging) return;
      var y = e.touches ? e.touches[0].clientY : e.clientY;
      var delta = y - dragFrom;
      if (delta < 0) delta = 0;
      sheet.style.transform = 'translateY(' + delta + 'px)';
      var scrim = root.querySelector('.mnbcat__scrim');
      if (scrim) scrim.style.opacity = String(Math.max(0, 1 - delta / 400));
    }

    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      var moved = parseFloat((sheet.style.transform.match(/([\d.]+)px/) || [0, 0])[1]);
      sheet.style.transform = '';
      var scrim = root.querySelector('.mnbcat__scrim');
      if (scrim) scrim.style.opacity = '';
      if (moved > 110) closeSheet();
    }

    ['[data-mnbcat-grab]', '[data-mnbcat-headbar]'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (!el) return;
      el.addEventListener('touchstart', dragStart, { passive: true });
      el.addEventListener('touchmove', dragMove, { passive: true });
      el.addEventListener('touchend', dragEnd);
      el.addEventListener('touchcancel', dragEnd);
    });

    /* Navigating away from a link inside the sheet leaves the scroll lock on
       if the browser restores the page from bfcache. */
    window.addEventListener('pageshow', function () {
      document.body.classList.remove('mnbcat-locked');
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mnbcat]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', initAll);
})();
